import { atom } from "jotai";

// Theme state
export const isDarkModeAtom = atom<boolean>(false);

// Authentication features removed
// Global store for any other app state can go here